import React from 'react';
import { BlockHandleMenu } from '../../../components/BlockHandleMenu';
import { renderIcon } from '../../../../SprintDetail/FlowchartView/utils/renderIcon';
import {
  CALLOUT_COLORS,
  CALLOUT_SURFACES,
  SURFACE_LABELS,
  SURFACE_TITLES,
  calloutColorSwatchStyle,
  calloutModePreviewStyle,
  hexPreviewStyle,
  parseHexColor,
} from '../utils/calloutTheme';

/**
 * Style / color / icon / wrap-unwrap menu. Portaled via BlockHandleMenu.
 */
export const CalloutMenu = ({
  blockId,
  menuPos,
  onClose,
  surface,
  color,
  rgb,
  isNeutral,
  hexDraft,
  setHexDraft,
  pickSurface,
  pickColor,
  applyHexDraft,
  showIcon = true,
  openIconPicker,
  icon,
  isQuote,
  handleIconChange,
  onWrapInCallout,
  onUnwrapCallout,
}) => (
  <BlockHandleMenu
    anchorBlockId={menuPos.anchorRect ? blockId : null}
    point={
      menuPos.anchorRect
        ? null
        : { x: menuPos.x || 0, y: menuPos.y || 0 }
    }
    onClose={onClose}
  >
    <div className="callout-menu__section-title">Style</div>
    <div className="callout-menu__modes">
      {CALLOUT_SURFACES.map((mode) => (
        <button
          key={mode}
          type="button"
          className={`callout-mode-option ${surface === mode ? 'is-active' : ''}`}
          title={SURFACE_TITLES[mode]}
          onClick={(e) => pickSurface(e, mode)}
        >
          <span
            className={`callout-mode-preview${mode === 'none' ? ' callout-mode-preview--none' : ''}`}
            style={calloutModePreviewStyle({ mode, isNeutral, rgb })}
          />
          {SURFACE_LABELS[mode]}
        </button>
      ))}
    </div>
    <div className="callout-menu__section-title">Color</div>
    <div className="callout-menu__swatches">
      {CALLOUT_COLORS.map((c) => (
        <button
          key={c}
          type="button"
          className={`callout-color-option ${c === color ? 'is-active' : ''}`}
          title={c[0].toUpperCase() + c.slice(1)}
          onClick={(e) => pickColor(e, c)}
        >
          <span className="callout-swatch" style={calloutColorSwatchStyle(c)} />
        </button>
      ))}
    </div>
    <div className="callout-menu__hex">
      <span
        className="callout-swatch callout-swatch--hex-preview"
        style={hexPreviewStyle(hexDraft)}
      />
      <input
        type="text"
        className="callout-menu__hex-input"
        placeholder="#hex"
        value={hexDraft}
        spellCheck={false}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setHexDraft(e.target.value)}
        onKeyDown={(e) => {
          e.stopPropagation();
          if (e.key === 'Enter') applyHexDraft();
        }}
      />
      <button
        type="button"
        className="callout-menu__hex-apply"
        disabled={!parseHexColor(hexDraft)}
        onClick={(e) => {
          e.stopPropagation();
          applyHexDraft();
        }}
      >
        Set
      </button>
    </div>
    {showIcon ? (
      <>
        <div className="callout-menu__divider" />
        <button type="button" className="callout-menu__item" onClick={openIconPicker}>
          <span className="callout-menu__item-icon">
            {icon
              ? renderIcon(icon, { size: '14px' })
              : <span className="callout-menu__item-icon-empty" aria-hidden>+</span>}
          </span>
          {icon ? 'Change icon…' : 'Add icon…'}
        </button>
        {icon && !isQuote ? (
          <button
            type="button"
            className="callout-menu__item"
            onClick={(e) => {
              e.stopPropagation();
              handleIconChange(null);
              onClose();
            }}
          >
            Remove icon
          </button>
        ) : null}
      </>
    ) : null}
    {onWrapInCallout && menuPos?.wrapIds?.length > 1 ? (
      <>
        <div className="callout-menu__divider" />
        <button
          type="button"
          className="callout-menu__item"
          onClick={(e) => {
            e.stopPropagation();
            const ids = menuPos.wrapIds;
            onClose();
            onWrapInCallout(blockId, { ids });
          }}
        >
          Convert to section
        </button>
      </>
    ) : null}
    {onUnwrapCallout ? (
      <>
        <div className="callout-menu__divider" />
        <button
          type="button"
          className="callout-menu__item"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
            onUnwrapCallout(blockId);
          }}
        >
          Remove section
        </button>
      </>
    ) : null}
  </BlockHandleMenu>
);
